import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Space, Tooltip } from 'antd';
import { useMemo } from 'react';
import { SubmissionScore } from '@module/assignment';
import { ScoreInput } from '../score-input';
import { QuestionTagComponent } from '../../question-tag';
import { isManuallyAwardedAnswer } from '../../utils/get-answer-grading-visual-status';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var QuestionCard = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: ", ";\n  background-color: ", ";\n  border: ", ";\n"])), function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 0;
  }

  return '16px 20px';
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'none';
  }

  return "0px 3px 6px rgba(0, 0, 0, 0.12)";
}, function (props) {
  var theme = props.theme;

  if (theme.media.isMobile) {
    return 'transparent';
  }

  return styleVariables.colors.gray1;
}, function (props) {
  var isSkipped = props.isSkipped,
      isEssayQuestion = props.isEssayQuestion,
      isCorrect = props.isCorrect,
      theme = props.theme,
      hasAnswer = props.hasAnswer,
      isManuallyAwarded = props.isManuallyAwarded;

  if (theme.media.isMobile) {
    return 0;
  }

  if (isSkipped) {
    return "1px solid ".concat(styleVariables.colors.red3);
  }

  if (isEssayQuestion) {
    return "1px solid ".concat(styleVariables.colors.blue2);
  }

  if (hasAnswer) {
    if (isCorrect) {
      return "1px solid ".concat(styleVariables.colors.green1);
    }

    if (isManuallyAwarded) {
      return "1px solid ".concat(styleVariables.colors.gold1);
    }

    return "1px solid ".concat(styleVariables.colors.red3);
  }

  return "1px solid ".concat(styleVariables.colors.gray4);
});
var QuestionContent = styled(MathEnabledTextComponent)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), styleVariables.colors.gray13);
var TitleArea = styled(Space)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var Content = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var Title = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n"])), styleVariables.colors.gray13);
var ExplanationArea = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: ", ";\n"])), styleVariables.colors.gray3);
var ExplanationTitle = styled.p(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 14px;\n  color: ", ";\n"])), styleVariables.colors.gray13);
var ExplanationContent = styled(MathEnabledTextComponent)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin: 0;\n  }\n"])), styleVariables.colors.gray13);
var StyledHeaderArea = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var StyledOnGradingText = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-style: italic;\n  color: ", ";\n  font-size: 14px;\n  line-height: 20px;\n  padding: 4px 8px;\n  text-align: center;\n"])), styleVariables.colors.gray10);

var isValidScore = function isValidScore(value) {
  return value !== undefined && value !== SubmissionScore["default"].value;
};

var getNormalizedScoreValue = function getNormalizedScoreValue(value) {
  return isValidScore(value) ? value : null;
};

var getScoreInputState = function getScoreInputState(value, isCorrect) {
  if (!isValidScore(value)) {
    return {
      active: false,
      danger: false,
      warning: false
    };
  }

  var isManuallyAwarded = !isCorrect && value > 0;
  return {
    active: value > 0 && !!isCorrect,
    danger: value === 0,
    warning: isManuallyAwarded
  };
};

export var GradingBaseAnswer = function GradingBaseAnswer(_ref) {
  var question = _ref.question,
      isSkipped = _ref.isSkipped,
      hasAnswer = _ref.hasAnswer,
      isCorrect = _ref.isCorrect,
      label = _ref.label,
      children = _ref.children,
      submitGradeAnswer = _ref.submitGradeAnswer,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      value = _ref.value,
      isAllQuestionAnswersGraded = _ref.isAllQuestionAnswersGraded,
      _ref$isResponderView = _ref.isResponderView,
      isResponderView = _ref$isResponderView === void 0 ? false : _ref$isResponderView,
      isShowingExplanation = _ref.isShowingExplanation,
      _ref$isEssayQuestion = _ref.isEssayQuestion,
      isEssayQuestion = _ref$isEssayQuestion === void 0 ? false : _ref$isEssayQuestion,
      _ref$isShowingScoreIn = _ref.isShowingScoreInput,
      isShowingScoreInput = _ref$isShowingScoreIn === void 0 ? true : _ref$isShowingScoreIn;
  var questionTypeTagLabel = useMemo(function () {
    return {
      skipped: label.skipped || 'Skipped',
      fillInBlankQuestion: label.fillInBlankQuestion,
      essayQuestion: label.essayQuestion,
      matchingQuestion: label.matchingQuestion,
      correct: label.correct,
      inCorrect: label.inCorrect
    };
  }, [label]);

  var renderExplanation = function renderExplanation() {
    if (question.explanation === undefined || !isShowingExplanation) {
      return null;
    }

    var isEmptyExplanation = question.explanation === '';
    var explanationContent = isEmptyExplanation ? /*#__PURE__*/_jsxs("i", {
      children: ["(", label.notHaveExplanationForThisQuestion, ")"]
    }) : /*#__PURE__*/_jsx(ExplanationContent, {
      value: question.explanation
    });
    return /*#__PURE__*/_jsxs(ExplanationArea, {
      children: [/*#__PURE__*/_jsx(ExplanationTitle, {
        children: label.explanation
      }), explanationContent]
    });
  };

  var renderResponderGradingState = function renderResponderGradingState() {
    return /*#__PURE__*/_jsx(StyledOnGradingText, {
      children: /*#__PURE__*/_jsx("i", {
        children: label.isOnGrading
      })
    });
  };

  var renderDisabledScoreInput = function renderDisabledScoreInput() {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: label.disabledScoreInputText,
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: question.score,
        label: label,
        submitScore: submitGradeAnswer,
        value: value,
        disabled: true
      })
    });
  };

  var isManuallyAwarded = isManuallyAwardedAnswer({
    isCorrect: isCorrect,
    score: value,
    hasGraded: isValidScore(value)
  });

  var renderActiveScoreInput = function renderActiveScoreInput() {
    var _getScoreInputState = getScoreInputState(value, isCorrect),
        active = _getScoreInputState.active,
        danger = _getScoreInputState.danger;

    return /*#__PURE__*/_jsx(Space, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: question.score,
        label: label,
        submitScore: submitGradeAnswer,
        value: getNormalizedScoreValue(value),
        active: active || isManuallyAwarded,
        danger: danger,
        disabled: disabled
      })
    });
  };

  var renderScoreInput = function renderScoreInput() {
    if (!isShowingScoreInput) {
      return null;
    }

    if (isResponderView && value === SubmissionScore["default"].value) {
      return renderResponderGradingState();
    }

    if (disabled && label.disabledScoreInputText) {
      return renderDisabledScoreInput();
    }

    return renderActiveScoreInput();
  };

  return /*#__PURE__*/_jsxs(QuestionCard, {
    id: question.id.toString(),
    isSkipped: isSkipped,
    isEssayQuestion: isEssayQuestion,
    hasAnswer: hasAnswer,
    isCorrect: isCorrect,
    isManuallyAwarded: isManuallyAwarded,
    direction: "vertical",
    size: "small",
    isAllQuestionAnswersGraded: isAllQuestionAnswersGraded,
    children: [/*#__PURE__*/_jsxs(StyledHeaderArea, {
      children: [/*#__PURE__*/_jsxs(TitleArea, {
        children: [/*#__PURE__*/_jsxs(Title, {
          children: [label.question, " ", question.titleIndex]
        }), /*#__PURE__*/_jsx(QuestionTagComponent, {
          question: question,
          isSkipped: isSkipped,
          hasAnswer: hasAnswer,
          isCorrect: isCorrect,
          score: value,
          hasGraded: typeof value === 'number' && value !== SubmissionScore["default"].value,
          label: questionTypeTagLabel
        })]
      }), renderScoreInput()]
    }), /*#__PURE__*/_jsx(QuestionContent, {
      value: question.description
    }), /*#__PURE__*/_jsx(Content, {
      children: children
    }), renderExplanation()]
  });
};